<template lang="pug">
modal(:max-width="400")
	.card.text-left
		.card-header.bg-warning
			span.fa.fa-edit.mr-2
			| Editor
			button.close(@click="cerrar") &times;
		.card-body
			.form-group
				label Título
				input.form-control(v-model="datos.Titulo", placeholder="Título del tema")

			.form-group
				label Descripción
				textarea.form-control(v-model="datos.Descripcion", rows="4", placeholder="Descripción del tema")

			.form-group
				label Fecha límite
				.input-group
					datepicker(
						v-model="datos.FechaLimite"
						:monday-first="true"
						input-class="form-control"
						:language="$dateLang"
						placeholder="Selecciona una fecha"
					)
					.input-group-append
						button.btn.btn-danger(@click="datos.FechaLimite = null")
							span.fa.fa-trash
		.card-footer
			button.btn.btn-sm.btn-primary(@click="guardar")
				span.fa.fa-save.mr-2
				| Guardar
</template>

<script>
export default {
	props: ['AgendaID'],
	data () {
		return {
			datos: {
				AgendaID: null,
				FechaLimite: new Date(),
				Titulo: null,
				Descripcion: null
			}
		}
	},
	created () {
		if (this.AgendaID && this.AgendaID !== 'nuevo') {
			this.getElemento(this.AgendaID)
		}
	},
	methods: {
		getElemento (AgendaID) {
			this.$http.post('redaccion/php/api/agenda/getAgenda.php', {AgendaID: AgendaID})
				.then(res => {
					if (res.data.FechaLimite) {
						res.data.FechaLimite = new Date(res.data.FechaLimite * 1000)
						this.datos = res.data
					}
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		guardar () {
			if (!this.datos.Titulo) {
				this.error('Debes proporcionar un título')
				return
			}

			const form = JSON.parse(JSON.stringify(this.datos))
			form.FechaLimite = (this.datos.FechaLimite) ? Math.floor(this.datos.FechaLimite.getTime() / 1000) : null
			this.$http.post('redaccion/php/api/agenda/setAgenda.php', form)
				.then(res => {
					this.$emit('actualizar')
					this.cerrar()
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		cerrar () {
			this.$emit('cerrar')
		},
		error (mensaje) {
			this.$store.commit('alertas/error', {
				titulo: 'Error',
				mensaje: mensaje
			})
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/redaccion/vue/componentes/agenda/editor.vue